import * as toastr from 'toastr';

export function configureToastr(){
     // Configure Toastr
     toastr.options.timeOut = 5000;
     toastr.options.closeButton = true;
     toastr.options.positionClass = 'toast-bottom-right';
     toastr.options.progressBar = true;
     toastr.options.preventDuplicates = false;// set to false to correct #14483
     toastr.options.escapeHtml = true;
}